import { PATCH_ORDER, type HubPlanetDto, type PatchKey } from '@aiai/shared';

export const PATCH_NAMES: Record<PatchKey, string> = {
  'first-launch': 'First launch',
  constellation: 'Constellation',
  century: 'Century',
  'green-streak': '10 green in a row',
  'clean-week': 'Clean week',
};

export const PATCH_GLYPHS: Record<PatchKey, string> = {
  'first-launch': '1',
  constellation: '★',
  century: '100',
  'green-streak': '10',
  'clean-week': '✓',
};

/** The planet's patches in PATCH_ORDER, at most `max` (the badges drawn on the planet). */
export function shownPatches(p: HubPlanetDto, max = 3): PatchKey[] {
  const have = new Set(p.patches ?? []);
  return PATCH_ORDER.filter((k) => have.has(k)).slice(0, max);
}

/** All of the planet's patch names, in PATCH_ORDER. */
export function patchNames(p: HubPlanetDto): string[] {
  return shownPatches(p, PATCH_ORDER.length).map((k) => PATCH_NAMES[k]);
}
